import { preparePhotoUploadFile } from "@/components/forms/media/file-helpers";

function needsJpegConversion(accept: string) {
  const types = accept.toLowerCase().split(",").map(type => type.trim());
  return types.some(type => ["image/jpeg", ".jpg", ".jpeg"].includes(type))
    && !types.some(type => ["*", "*/*", "image/*", "image/heic", "image/heif", ".heic", ".heif"].includes(type));
}

export function getPreparedUploadAccept(accept = "*") {
  return needsJpegConversion(accept) ? `${accept},.heic,.heif,image/heic,image/heif` : accept;
}

export async function prepareAcceptedUploadFile(file: File, accept = "*") {
  return needsJpegConversion(accept) ? preparePhotoUploadFile(file) : file;
}
